import React, { useEffect } from "react";
import AOS from "aos";
import { profile } from "../data/profile";
import "../App.css";

function Education() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <section id="education" className="site-section site-section--surface">
      <div className="container site-section-inner">
        <header className="section-head">
          {/* <p className="section-eyebrow">Academics</p> */}
          <h2 className="section-title">Education</h2>
          {/* <p className="section-lead">Formal grounding in computer science and engineering.</p> */}
        </header>

        <div className="education-list" data-aos="fade-up">
          {profile.education.map((ed) => (
            <article className="education-item" key={ed.school}>
              <h3>{ed.school}</h3>
              <p>{ed.degree}</p>
              <span>{ed.duration}</span>
              <p>Coursework: {ed.Coursework.join(", ")}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Education;
